import { render, staticRenderFns } from "./NewOnYourServicesTitleList.vue?vue&type=template&id=f21ae1da&scoped=true"
import script from "./NewOnYourServicesTitleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewOnYourServicesTitleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewOnYourServicesTitleList.vue?vue&type=style&index=0&id=f21ae1da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21ae1da",
  null
  
)

export default component.exports